import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { WHATSAPP_URL, TEL_PRIMARY } from "../lib/business";

export const FloatingWhatsApp = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Chamar no WhatsApp"
    className="hidden md:flex fixed bottom-8 right-8 z-50 h-16 w-16 bg-[#25D366] hover:bg-[#1EBE5D] rounded-full items-center justify-center shadow-[0_0_30px_rgba(37,211,102,0.5)] transition-transform hover:scale-110 pulse-ring"
  >
    <MessageCircle className="w-8 h-8 text-white" strokeWidth={2.5} />
  </a>
);

export const MobileCallBar = () => (
  <div
    data-testid="mobile-fixed-call-bar"
    className="md:hidden fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 h-16 shadow-[0_-4px_24px_rgba(0,0,0,0.8)]"
  >
    <a
      href={TEL_PRIMARY}
      data-testid="mobile-fixed-call-button"
      className="bg-[#E50914] hover:bg-[#B80710] text-white flex items-center justify-center font-anton text-lg uppercase gap-2 tracking-wider active:scale-95 transition-transform"
    >
      <Phone className="w-5 h-5" strokeWidth={2.5} />
      Ligar Agora
    </a>
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-fixed-whatsapp-button"
      className="bg-[#25D366] hover:bg-[#1EBE5D] text-white flex items-center justify-center font-anton text-lg uppercase gap-2 tracking-wider active:scale-95 transition-transform"
    >
      <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
      WhatsApp
    </a>
  </div>
);
